export default "/_next/static/images/product--reports-legacy-289d7cc47c6531ea88ed4d4ed8eb65f3.svg";